import { REPLACE_KEYS_TO_TREE_OBJ } from "features/Inventario/constants/constants"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'map-...
import mapKeysDeep from "map-keys-deep-lodash"

export const catalogosSelector = (state: $TSMigrationFixMe) => state.catalogos

export const manyArticulosSelectedSelector = (state: $TSMigrationFixMe) => {
  const { articulosSelected } = state.catalogos

  return Object.keys(articulosSelected).reduce(
    (total, categoriaName) =>
      total + articulosSelected[categoriaName]?.articulos?.length || 0,
    0
  )
}

export const categoriasTreeSelector = (state: $TSMigrationFixMe) => {
  const { categoriasTree } = state.catalogos

  return mapKeysDeep(
    categoriasTree,
    (_: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      return REPLACE_KEYS_TO_TREE_OBJ[key] ? REPLACE_KEYS_TO_TREE_OBJ[key] : key
    }
  )
}

export const getCategoriasFromCatalogo = (state: $TSMigrationFixMe) => {
  const { categorias } = state.catalogos

  return categorias?.map((categoria: $TSMigrationFixMe) => ({
    label: categoria.nombre,
    value: categoria.id,
  }))
}

export const getCatalogoSelector = (state: $TSMigrationFixMe) => {
  const { catalogo, fetchingCatalogo, categorias } = state.catalogos
  return { catalogo, fetchingCatalogo, categorias }
}

export const isReadyToCreateOrUpdateCatalogo = (state: $TSMigrationFixMe) => {
  const { fetchingArticulos, fetchingCatalogosTree } = state.catalogos

  return !fetchingArticulos && !fetchingCatalogosTree
}
